import { resolve, storeHomeNVClient, ImResponse } from '.';
import { LazadaStandaloneAuthResultBody } from './admin';
import { AuthShopOpenMode } from './flagr';
import { AeAuthResult } from './aliexpress/authAEShopByCode';

export interface GenerateTikTokAuthUrlParams {
  departments: number[];
  openMode?: AuthShopOpenMode;
  storeType?: 'LOCAL' | 'CROSS';
  region?: General.UpperCaseRegion;
}

export function generateAuthUrl(params: GenerateTikTokAuthUrlParams) {
  return resolve<string>(
    storeHomeNVClient.get('/tiktok/generateAuthUrl', {
      params: {
        ...params,
        departmentIds: params.departments.join(','),
      },
    }),
  );
}

export function generateTiktokUSAuthUrl(params: GenerateTikTokAuthUrlParams) {
  return resolve<string>(
    storeHomeNVClient.get('/tiktok/us/generateAuthUrl', {
      params: {
        ...params,
        departmentIds: params.departments.join(','),
      },
    }),
  );
}

export interface IAuthTiktok {
  code: string;
  // state: string;
  departmentIds: number[];
}

export function auth(body: IAuthTiktok) {
  return resolve(storeHomeNVClient.post<ImResponse<AeAuthResult>>('/tiktok/auth', body));
}

export function authTiktokUS(body: IAuthTiktok) {
  return resolve(storeHomeNVClient.post<ImResponse<AeAuthResult>>('/tiktok/us/auth', body));
}

export const ErrorMap = {
  1053: 'TIKTOK非东南亚站点店铺无法授权',
};

export interface TiktokStandaloneAuthResultBody extends LazadaStandaloneAuthResultBody {
  errorCode: 1053;
}

export function tiktokStandaloneResult(uuid: string) {
  return resolve<TiktokStandaloneAuthResultBody>(
    storeHomeNVClient.get('/tiktok/standalone_result', {
      params: {
        uuid,
      },
    }),
  );
}

export function tiktokUSStandaloneResult(uuid: string) {
  return resolve<TiktokStandaloneAuthResultBody>(
    storeHomeNVClient.get('/tiktok/us/standalone_result', {
      params: {
        uuid,
      },
    }),
  );
}

// 服务市场授权
export const authLazadaService = (body: IAuthTiktok) => {
  return resolve(storeHomeNVClient.post<ImResponse<AeAuthResult>>('/lazada/auth', body));
};

export const authBI = (code: string, token: string) => {
  return resolve(
    storeHomeNVClient.post<ImResponse<{ isSuccess: boolean }>>(
      '/lazada/auth/bi',
      { code },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    ),
  );
};
